function isValidURL(url) {
    try {
        new URL(url);
    }
    catch (e) {
        return false;
    }
    return true;
}
export default isValidURL;
//# sourceMappingURL=is-valid-url.js.map